goog.provide('yext.entity.fields.video.YouTubeVideoListField');
goog.provide('yext.entity.fields.video.YouTubeVideoField');
goog.provide('yext.entity.fields.video.YouTubeVideo');
goog.provide('yext.entity.fields.video.VideoModel');

goog.require('yext');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.textfield.TextField');
goog.require('yext.location.helpers');
goog.require('yext.youtube');
goog.require('yext.utils.youtube');

/**
 * Data Model for a generic video field.
 *
 * @param {!Object} data Parent element for the field
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 *
 * youTubeVideoInfo contains data to display the video.
 * It is part of main model and not part of asset model since
 * this information is needed to render video at all times
 */
yext.entity.fields.video.VideoModel = function(data) {
  this.url = yext.isString(data.url) ? data.url : '';
  this.indeterminate = yext.isBoolean(data.indeterminate) ? data.indeterminate : false;
  this.youTubeVideoInfo = yext.isObject(data.youTubeVideoInfo) ? data.youTubeVideoInfo : undefined;
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.entity.fields.video.VideoModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Set the indeterminate for this field.
 *
 * @param {boolean} indeterminate The target value
 */
yext.entity.fields.video.VideoModel.prototype.setIndeterminate = function(indeterminate) {
  if (yext.isBoolean(indeterminate) && this.indeterminate != indeterminate) {
    this.indeterminate = indeterminate;
    this.emitUpdate();
  }
};

/**
 * Set the videoinfo for this field.
 *
 * @param {!Object} videoinfo The target value
 */
yext.entity.fields.video.VideoModel.prototype.setYouTubeVideoInfo = function(youTubeVideoInfo) {
  if (yext.isObject(youTubeVideoInfo)) {
    this.youTubeVideoInfo = youTubeVideoInfo;
  }
};

/**
 * Returns a copy of the current model
 */
yext.entity.fields.video.VideoModel.prototype.copy = function() {
  return {
    url: this.url,
    indeterminate: this.indeterminate,
    youTubeVideoInfo: this.youTubeVideoInfo,
  };
};

/**
 * Models a generic YouTube video.
 *
 * @param {!Object} data information to initialize video with
 * @param {string} thumbnailTemplate template for rendering video thumbnail
 * @param {string} editTemplate template for rendering video in edit mode
 * @param {string} viewTemplate template for rendering video in view mode
 * @param {string} parentFieldId field id of the parent wrapper
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.entity.fields.video.YouTubeVideo = function(data, thumbnailTemplate, editTemplate, viewTemplate, viewOnly, parentFieldId, displayDescription) {
  this.$ctx = $(editTemplate);
  this.$removeVideo = this.$ctx.find('.js-remove-video');
  this.$videoSelectedCheckbox = this.$ctx.find('.js-video-selected-checkbox');
  this.$ctx.data('video', this);

  this.fieldId = parentFieldId;
  this.thumbnailTemplate = thumbnailTemplate;
  this.viewTemplate = viewTemplate;
  this.model = new yext.entity.fields.video.VideoModel(data.video);
  this.displayDescription = displayDescription;
  if (this.displayDescription) {
    this.description = this.buildDescription(data.description, viewOnly);
  }

  this.updateVideoDisplayEditMode();
  this.bindUpdates();
  this.bindRemoveVideo();
  this.bindVideoSelectedCheckbox();
};

/**
 * Bind click events to show the remove youtube video dialog
 */
yext.entity.fields.video.YouTubeVideo.prototype.isSelected = function() {
  if (this.$videoSelectedCheckbox.length) {
    return this.$videoSelectedCheckbox.prop('checked');
  }
  return true;
};

/**
 * Hide Remove button
 */
yext.entity.fields.video.YouTubeVideo.prototype.hideRemoveButton = function() {
  if (this.$removeVideo) {
    this.$removeVideo.hide();
  }
};

/**
 * Returns true if video is indeterminate
 */
yext.entity.fields.video.YouTubeVideo.prototype.isIndeterminate = function() {
  return this.model.indeterminate;
};

/**
 * Bind the video selected checkbox
 */
yext.entity.fields.video.YouTubeVideo.prototype.bindVideoSelectedCheckbox = function() {
  var self = this;
  if (this.$videoSelectedCheckbox.length) {
    this.$videoSelectedCheckbox.on('click change', function(e) {
      // If the state was indeterminate, set the checkbox to checked
      if (self.model.indeterminate) {
        self.$videoSelectedCheckbox.prop('checked', true);
      }
      self.model.setIndeterminate(false);
      self.emitUpdate();
    });
  }
};

/**
 * Updates the video display with the current videoinfo
 *
 * @param {!jQuery} $ctx video view object or video edit object
 */
yext.entity.fields.video.YouTubeVideo.prototype.updateVideoDisplayEditMode = function() {
  var html = '';
  if (this.model.youTubeVideoInfo) {
    html = yext.utils.youtube.fixupVideoTemplate(this.thumbnailTemplate, this.model.youTubeVideoInfo);
  } else {
    html = this.getErrorMessage();
  }
  if (this.$videoSelectedCheckbox.length) {
    this.$videoSelectedCheckbox.prop('indeterminate', this.model.indeterminate);
  }
  this.$ctx.find('.js-video-display-edit').html(html);
};

/**
 * Builds description view
 */
yext.entity.fields.video.YouTubeVideo.prototype.buildDescription = function(data, viewOnly) {
  var usageType = goog.module.get('yext.dam.assetselector.usage').forProfileFields(this.fieldId);
  var description = new yext.textfield.TextField(this.$ctx.find('.js-video-description-edit'), undefined, undefined, undefined, viewOnly, usageType);
  description.set(data);
  return description;
};

/**
 * Returns html that matches view mode for a YouTubeVideo
 */
yext.entity.fields.video.YouTubeVideo.prototype.templateView = function() {
  var html = '';
  if (this.model.youTubeVideoInfo) {
    var video = yext.utils.youtube.fixupVideoTemplate(
      this.thumbnailTemplate,
      this.model.youTubeVideoInfo);
    if (this.viewTemplate) {
      html = this.viewTemplate.replace(/{{=video}}/, video);
      if (this.displayDescription) {
        html = html.replace(/{{=description}}/, this.description.viewMarkupAsString());
      }
    }
  } else {
    html = this.getErrorMessage();
  }
  return html;
};

/**
 * Returns error message for the field
 */
yext.entity.fields.video.YouTubeVideo.prototype.getErrorMessage = function() {
  return yext.msg(
    'There was an error retrieving video details from Youtube.' +
    ' The <a href="{0}">video</a> may be private or unavailable.',
    this.model.url);
};

/**
 * Bind click events to show the remove youtube video dialog
 */
yext.entity.fields.video.YouTubeVideo.prototype.bindRemoveVideo = function() {
  if (this.$removeVideo.length) {
    var self = this;
    this.$removeVideo.click(function() {
      $(self).trigger('delete');
    });
  }
};

/**
 * Bind updates from youtube video field
 */
yext.entity.fields.video.YouTubeVideo.prototype.bindUpdates = function() {
  var self = this;
  if (this.displayDescription) {
    $(this.description).on('update.textField', function() {
      self.emitUpdate();
    });
  }

  $(this.model).on('updated', function() {
    self.emitUpdate();
  });
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.entity.fields.video.YouTubeVideo.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Get the current state of the field
 */
yext.entity.fields.video.YouTubeVideo.prototype.getData = function() {
  var data = {
    video: this.model.copy(),
  };
  if (this.displayDescription) {
    data['description'] = this.description.coreData();
  }
  return data;
};

/**
 * Models a youTube video field.
 *
 * @param {!jQuery} $ctx Parent element for the field
 * @param {boolean} viewOnly whether the field should be rendered as view only
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.entity.fields.video.YouTubeVideoField = function($ctx, viewOnly, $viewDisplayForStruct, isChildOfStructList) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-youTube-video-field').addBack().filter('.js-youTube-video-field');
  this.$fieldValue = this.$field.find('.js-field-value');
  this.$addVideoButton = this.$field.find('.js-add-video');
  this.$editDisplay = this.$field.find('.js-video-edit-content');
  if ($viewDisplayForStruct) {
    this.$viewDisplay = $viewDisplayForStruct.find('.js-video-display-view');
  } else {
    this.$viewDisplay = this.$field.find('.js-video-display-view');
  }
  this.$edit = this.$field.find('.js-video-edit');
  this.$resetAll = this.$field.find('.js-reset-all');
  this.$indeterminateMsg = this.$field.find('.js-indeterminate-message');
  this.$errorContainer = this.$field.find('.js-field-error');

  this.videoInfoCache = {};

  this.editTemplate = this.$field.find('.js-video-edit-template').html();
  if ($viewDisplayForStruct) {
    this.viewTemplate = $viewDisplayForStruct.find('.js-video-display-template').html();
  } else {
    this.viewTemplate = this.$field.find('.js-video-display-template').html();
  }
  this.videoTemplate = this.$field.find('.js-video-thumbnail-template').html();
  this.fieldId = this.$field.data('fieldId');
  this.assetsOnly = this.$field.data('assetsOnly');
  this.displayDescription = this.$field.data('displayDescription');
  this.viewOnly = viewOnly;
  this.isChildOfStructList = isChildOfStructList;
  this.build();

  this.assetOrOriginal = true;
  this.originalValue = null;
};

/**
 * Intilaize properties/bindings for field
 */
yext.entity.fields.video.YouTubeVideoField.prototype.build = function() {
  var data = this.$field.data('value');
  var self = this;

  this.model = {
    indeterminate: data['displayIndeterminate'],
    timestamp: data['timestamp'],
  };
  if (data['displayUrl']) {
    var info = {
      url: data['displayUrl'],
    };
    if (this.displayDescription) {
      info['description'] = data['description'];
    }
    this.loadVideoDetails(info, function(video) {
      self.model.video = video;

      if (self.isChildOfStructList) {
        self.model.video.hideRemoveButton();
      }
      var overridden = (!data['url'] && data['displayUrl']);
      self.continueSetup(overridden);
    });
  } else {
    this.continueSetup();
  }
};

/**
 * Package relevant field info to send to a parent struct.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.getJSONData = function() {
  this.setFieldValue();
  return JSON.parse(this.$fieldValue.val());
};

/**
 * Update the given template with new values and append it to the view
 */
yext.entity.fields.video.YouTubeVideoField.prototype.updateTemplate = function(fieldValues, $display, $viewTemplate) {
  var self = this;

  if (fieldValues.url) {
    var youtubeId = yext.youtube.parseIdFromUrl(fieldValues.url);
    var html = $viewTemplate.find('.js-video-display-template').html();
    var success = function(videos) {
      var formatted = self.formatData(fieldValues, videos[0]);
      if (formatted.video.url) {
        var video = yext.utils.youtube.fixupVideoTemplate(
          self.videoTemplate,
          formatted.video.youTubeVideoInfo);
        html = html.replace(/{{=video}}/, video);

        if (self.displayDescription) {
          var usageType = goog.module.get('yext.dam.assetselector.usage').forProfileFields(self.fieldId);
          var description = new yext.textfield.TextField(
            $(self.editTemplate).find('.js-video-description-edit'),
            undefined,
            undefined,
            undefined,
            self.viewOnly,
            usageType);
          description.set(formatted.description);
          html = html.replace(/{{=description}}/, description.viewMarkupAsString());
        }
      }

      // In order to render descriptions properly, the display must maintain the parent context
      // of 'js-youtube-video-field'. We therefore only clear children of the
      // 'js-youtube-video-field' div.
      var update = $display.find('.js-youTube-video-field').empty().append(html);
      $display.append(update);
    };
    var failure = function(videos) {
      self.showError(yext.msg('Unable to load video details'));
    };
    yext.youtube.getVideosDetails([youtubeId], success, failure);
  }
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues, () => $.noop());
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$fieldValue.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * Empty out potential description asset id.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.clearAsset = function() {
  // TODO (jballschneider): Figure out if we need to / how to clear asset from description.
};

/**
 * The after save function when this youtube video field is a child of a struct.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate, cannotEdit) {
  var self = this;
  self.viewOnly = cannotEdit;

  if ($viewTemplate) {
    this.updateTemplate(fieldValues, $display, $viewTemplate);
  }
  this.setFromResponse(fieldValues, function() {
    self.storeValue();
  });

  // reset asset approvals values
  this.assetOrOriginal = true;
  this.originalValue = this.$fieldValue.val();
};

/**
 * Loads new YouTubeVideo from data and callback
 *
 * @param {!Object} data information to build a YouTubeVideo view
 * @param {callback} cb actions to perform post loading video
 */
yext.entity.fields.video.YouTubeVideoField.prototype.loadVideoDetails = function(data, cb) {
  var self = this;
  var youtubeId = yext.youtube.parseIdFromUrl(data.url);

  if (this.videoInfoCache[data.url]) {
    var info = this.formatData(data, this.videoInfoCache[data.url]);
    cb(self.newVideo(info));
  } else {
    yext.youtube.getVideosDetails([youtubeId], function(videos) {
      self.buildNewVideo(data, cb, videos[0]);
      $(self).trigger('nonAssetClearingUpdate.list');
      $(self).trigger('nonAssetClearingUpdate.struct');
    },
    function() {
      // Error because of youtube api
      self.buildNewVideo(data, cb);
      self.showError();
    });
  }
};

/**
 * Makes new video and caches the youTubeVideoInfo
 *
 * @param {!Object} data information to initialize video model
 * @param {callback} cb
 * @param {!Object} youTubeVideoInfo contains data to display the video.
 */
yext.entity.fields.video.YouTubeVideoField.prototype.buildNewVideo = function(data, cb, youTubeVideoInfo) {
  var info = this.formatData(data, youTubeVideoInfo);
  this.videoInfoCache[info.video.url] = info.video.youTubeVideoInfo;
  cb(this.newVideo(info));
  this.originalValue = this.$fieldValue.val();
};

/**
 * Formats the data
 *
 * @param {!Object} data information to initialize video model
 * @param {!Object} youTubeVideoInfo contains data to display the video.
 * @return {!Object} data format used by yext.entity.fields.video.YouTubeVideo
 */
yext.entity.fields.video.YouTubeVideoField.prototype.formatData = function(data, youTubeVideoInfo) {
  var formatted = {
    video: {
      url: data.url,
      youTubeVideoInfo: youTubeVideoInfo,
    },
  };
  if (this.displayDescription) {
    formatted['description'] = data.description;
  }
  return formatted;
};

/**
 * Sets indeterminate property on the field model
 *
 * @param {boolean} indeterminate target value
 */
yext.entity.fields.video.YouTubeVideoField.prototype.setIndeterminate = function(indeterminate) {
  if (yext.isBoolean(indeterminate) && this.model.indeterminate != indeterminate) {
    this.model.indeterminate = indeterminate;
    this.render();
    this.emitUpdate();
  }
};

/**
 * Helps bind additional properties for field, Used as a callback function
 */
yext.entity.fields.video.YouTubeVideoField.prototype.continueSetup = function(overridden = false) {
  this.renderDisplayView();

  // if the video was inherited from the primary profile, continue setup as if it isn't there
  if (overridden) {
    this.model.video = null;
  }

  this.storeValue();
  this.bindAddVideo();
  this.bindResetAll();
  this.bindUpdates();
  this.render();
  this.setFieldValue();
  this.originalValue = this.$fieldValue.val();
};

/**
 * Inserts view for YouTubeVideo in DOM
 */
yext.entity.fields.video.YouTubeVideoField.prototype.renderDisplayView = function() {
  if (this.model.indeterminate) {
    this.$viewDisplay.empty().append(yext.location.helpers.variousContentMessage());
  } else if (this.model.video) {
    this.$viewDisplay.empty().append(this.model.video.templateView());
  } else {
    this.$viewDisplay.empty().append(yext.location.helpers.emptyFieldMessage());
  }
};

/**
 * 'Add youtube video' links
 *
 * Bind click events to show the add youtube video dialog
 */
yext.entity.fields.video.YouTubeVideoField.prototype.bindAddVideo = function() {
  var self = this;
  this.$addVideoButton.on('click', function() {
    self.showAssetSelector();
  });
};

/**
 * Show/bind the asset selector
 */
yext.entity.fields.video.YouTubeVideoField.prototype.showAssetSelector = function() {
  var self = this;
  var isChildOfStruct = this.$ctx.parents('.js-struct-field').length > 0;
  var parentFieldId = (isChildOfStruct ? this.$ctx.closest('tr').data('fieldId') : this.fieldId) || this.fieldId;

  yext.dam.assetselector.events.show({
    type: yext.dam.assetselector.types.VIDEO,
    includeUsedAssets: false,
    hideNonAssetVideoTabs: self.assetsOnly,
    isSuggestedEditMode: false,
    usageType: goog.module.get('yext.dam.assetselector.usage').forProfileFields(parentFieldId),
  },
  self.fieldId);
  $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
    self.newVideoFromAsset(asset);
  });
};

/**
 * Creates new YouTubeVideo from asset
 *
 * @param {!Object} asset data selected from asset selector
 */
yext.entity.fields.video.YouTubeVideoField.prototype.newVideoFromAsset = function(asset) {
  if (asset === undefined) return;
  var self = this;
  var data = {
    url: asset.videoinfo.url,
  };
  if (this.displayDescription) {
    data['description'] = {
      value: asset.description,
      displayValue: asset.description,
    };
  }
  this.loadVideoDetails(data, function(video) {
    self.setVideo(video);
    $(self).trigger('newVideoFromAsset');
    self.setFieldValue();
  });
};

/**
 * Bind updates from youtube video field
 */
yext.entity.fields.video.YouTubeVideoField.prototype.bindUpdates = function() {
  var self = this;
  if (this.model.video) {
    $(this.model.video).on('updated', function() {
      self.setFieldValue();
      self.emitUpdate();
    });

    $(this.model.video).on('delete', function() {
      self.setVideo();
      self.emitUpdate();
      self.setFieldValue();
    });
  }
};

/**
 * Bind reset link in bulk edit mode
 */
yext.entity.fields.video.YouTubeVideoField.prototype.bindResetAll = function() {
  var self = this;
  this.$resetAll.click(function() {
    self.setIndeterminate(false);
    self.setFieldValue();
  });
};

/**
 * Creates an update for 'data-value' attribute in the field
 */
yext.entity.fields.video.YouTubeVideoField.prototype.updateFieldData = function() {
  var fieldValue = this.createFieldValue();
  var url = fieldValue['url'];
  var indeterminate = fieldValue['indeterminate'];
  if (fieldValue.url) {
    fieldValue['displayUrl'] = url;
  } else {
    fieldValue['displayUrl'] = '';
  }
  if (fieldValue.indeterminate) {
    fieldValue['displayIndeterminate'] = indeterminate;
  } else {
    fieldValue['displayIndeterminate'] = false;
  }

  if (fieldValue.description) {
    var description = fieldValue.description.value;
    var descriptionIndeterminate = fieldValue.description.indeterminate;

    fieldValue['description'] = {
      displayValue: description,
      indeterminate: descriptionIndeterminate,
      displayIndeterminate: descriptionIndeterminate,
      completedValue: description,
      value: description,
      displayCompletedValue: description,
    };
  }
  return JSON.stringify(fieldValue);
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.entity.fields.video.YouTubeVideoField.prototype.emitUpdate = function() {
  this.$field.attr('data-value', this.updateFieldData());
  $(this).trigger('updated');
  $(this).trigger('update.list');
  $(this).trigger('update.struct');
  this.updateAssetOrOriginal(false);
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.entity.fields.video.YouTubeVideoField.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.createFieldValue()));
};

/**
 * Create field value
 */
yext.entity.fields.video.YouTubeVideoField.prototype.createFieldValue = function() {
  var fieldValue = {
    'timestamp': this.model.timestamp,
    'indeterminate': this.model.indeterminate,
  };
  if (this.model.video) {
    var data = this.getJSONDataInternal();
    fieldValue['url'] = data['url'];
    if (this.displayDescription) {
      fieldValue['description'] = data['description'];
    }
  } else {
    fieldValue['url'] = '';
  }
  return fieldValue;
};

/**
 * Convert the current state of field to correct json format
 */
yext.entity.fields.video.YouTubeVideoField.prototype.getJSONDataInternal = function() {
  var data = this.model.video.getData();
  var jsonData = {
    'url': data.video.url,
  };
  if (this.displayDescription) {
    jsonData['description'] = data.description;
  }
  return jsonData;
};

/**
 * Reset the field to the stored state
 */
yext.entity.fields.video.YouTubeVideoField.prototype.reset = function() {
  this.set(this.storedValue, function() {});
};

/**
 * Return true if the field is empty
 */
yext.entity.fields.video.YouTubeVideoField.prototype.isEmpty = function() {
  return !this.isVideoPresent() && !this.model.indeterminate;
};

/**
 * Return true if the field is empty
 */
yext.entity.fields.video.YouTubeVideoField.prototype.isVideoPresent = function() {
  return !!this.model.video;
};

/**
 * Set the youtube video data from response
 *
 * @param {JSONObject} jsonData information to fill in a youtube video
 */
yext.entity.fields.video.YouTubeVideoField.prototype.setFromResponse = function(jsonData, cb) {
  var self = this;
  var fieldsToSet = {
    url: jsonData['url'],
    timestamp: jsonData['timestamp'],
    indeterminate: jsonData['indeterminate'],
  };

  if (this.displayDescription) {
    fieldsToSet['description'] = jsonData['description'];
  }
  this.set(
    fieldsToSet,
    function() {
      self.renderDisplayView();
      cb();
    },
  );
};

/**
 * Set the youtube video data and trigger a change event
 *
 * @param {!Object} data information to fill in a youtube video
 * @param {function()} cb callback used to render video in view mode post save
 */
yext.entity.fields.video.YouTubeVideoField.prototype.set = function(data, cb) {
  var self = this;
  if (data.indeterminate) {
    this.model.indeterminate = data.indeterminate;
  }

  if (data.url) {
    this.loadVideoDetails(data, function(video) {
      self.setVideo(video);
      self.setFieldValue();
      cb();
    });
  } else {
    self.setVideo();
    self.setFieldValue();
    cb();
  }

  if (data.timestamp) {
    this.model.timestamp = data.timestamp;
  }
};

/**
 * @param {!Object} info information to initialize yext.entity.fields.video.YouTubeVideo
 * @return {yext.entity.fields.video.YouTubeVideo}
 */
yext.entity.fields.video.YouTubeVideoField.prototype.newVideo = function(info) {
  return new yext.entity.fields.video.YouTubeVideo(
    info,
    this.videoTemplate,
    this.editTemplate,
    this.viewTemplate,
    this.viewOnly,
    this.fieldId,
    this.displayDescription);
};

/**
 * @return {boolean} True if the field has changed since the last save
 */
yext.entity.fields.video.YouTubeVideoField.prototype.hasChanges = function() {
  if (this.model.video && !this.storedValue.url) { // change from empty state to filled state
    return true;
  } else if (this.model.video) { // change in video (remains in filled state)
    return this.model.video.model.url != this.storedValue.url;
  } else if (this.storedValue.url) { // change from filled state to empty state
    return true;
  }
  return false;
};

/**
 * Render the field given its state
 */
yext.entity.fields.video.YouTubeVideoField.prototype.render = function() {
  this.$errorContainer.hide();
  this.$indeterminateMsg.toggle(this.model.indeterminate);
  this.$editDisplay.toggle(!this.model.indeterminate);
  this.$addVideoButton.toggle(this.isEmpty());
  this.$editDisplay.empty();
  if (this.isVideoPresent()) {
    this.$editDisplay.append(this.model.video.$ctx);
  }
};

/**
 * Set the video and trigger update
 *
 * @param {!yext.entity.fields.video.YouTubeVideo} video
 */
yext.entity.fields.video.YouTubeVideoField.prototype.setVideo = function(video) {
  this.model.video = video;
  this.render();
  this.bindUpdates();
};

/**
 * Store the value so that it can be restored later
 */
yext.entity.fields.video.YouTubeVideoField.prototype.storeValue = function() {
  this.storedValue = {
    indeterminate: this.model.indeterminate,
  };
  if (this.model.video) {
    var data = this.model.video.getData();
    this.storedValue.url = data.video.url;
    if (this.displayDescription) {
      this.storedValue.description = data.description;
    }
  }
};

/**
 * Show an error when something goes wrong
 *
 * @param {string} msg Error message to display
 */
yext.entity.fields.video.YouTubeVideoField.prototype.showError = function(msg) {
  msg = msg || yext.msg('Something went wrong, please reload the page');
  this.$errorContainer.html(msg).show();
};

/**
 * clears field
 */
yext.entity.fields.video.YouTubeVideoField.prototype.clear = function() {
  this.setVideo();
};

/**
 * Models a youTube video list field.
 *
 * @param {!jQuery} $ctx Parent element for the field
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.entity.fields.video.YouTubeVideoListField = function($ctx, viewOnly) {
  this.$ctx = $ctx;
  this.$field = $ctx.find('.js-youTube-video-list-field').addBack().filter('.js-youTube-video-list-field');
  this.$list = this.$field.find('.js-video-list-list');
  this.$elidedModeContainer = this.$field.find('.js-elided-mode-container');
  this.$viewDisplay = this.$field.find('.js-video-list-display-view');
  this.$addVideoButton = this.$field.find('.js-add-video');
  this.$orderVaries = this.$field.find('.js-order-varies');
  this.$edit = this.$field.find('.js-video-list-edit');
  this.$fieldValue = this.$field.find('.js-field-value');
  this.$editAllContainer = this.$field.find('.js-video-list-edit-all');
  this.$editAllCheckbox = this.$field.find('.js-video-list-edit-all-checkbox');
  this.$errorContainer = this.$field.find('.js-field-error');

  this.videoInfoCache = {};

  this.viewTemplate = this.$field.find('.js-video-list-display-template').html();
  this.editTemplate = this.$field.find('.js-video-list-edit-template').html();
  this.thumbnailTemplate = this.$field.find('.js-video-thumbnail-template').html();
  this.fieldId = this.$field.data('fieldId');
  this.assetsOnly = this.$field.data('assetsOnly');
  this.displayDescription = this.$field.data('displayDescription');

  this.viewOnly = viewOnly;

  this.build();
};

/**
 * Intilaize properties/bindings for field
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.build = function() {
  var data = this.$field.data('value');
  var self = this;

  this.model = {
    timestamp: data['timestamp'],
    elidedVideoCount: data['displayElidedVideoCount'],
    orderVaries: data['orderVaries'],
  };

  this.getVideosDetails(data['displayVideos'], function(videos) {
    self.model.videos = videos;
    self.continueSetup(data['isInheritedData']);
  });
};

/**
 * Wrapper for extracting the video modules from their DOM elements
 *
 * @param {!Object} videosData object containing videos data
 * @param {callback} cb
 * @return {!Array.<yext.entity.fields.video.YouTubeVideo>} List of videos in this gallery
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.getVideosDetails = function(videosData, cb) {
  var self = this;
  var videos = videosData.map(function(videoData) {
    return self.extractDataFromJson(videoData);
  });
  return this.extractVideos(videos, cb);
};

/**
 * Provides core functionality for extracting the video modules from their DOM elements
 *
 * @param {!Object} videosData object containing videos data
 * @param {callback} cb
 * @return {!Array.<yext.entity.fields.video.YouTubeVideo>} List of videos in this gallery
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.extractVideos = function(videosData, cb) {
  if (videosData.length == 0) {
    return cb([]);
  }
  var self = this;
  var youtubeIds = [];

  // if the cache contains all video info, short-circuit
  if (this.allValuesInCache(videosData)) {
    var videoInfos = this.getVideosInfoFromCache(videosData);
    cb(this.loadNewVideos(videosData, videoInfos));
  } else {
    for (var i = 0; i < videosData.length; i++) {
      youtubeIds.push(yext.youtube.parseIdFromUrl(videosData[i].video.url));
    }

    yext.youtube.getVideosDetails([youtubeIds], function(videoInfos) {
      cb(self.loadNewVideos(videosData, videoInfos));
    },
    function() {
      // Error because of youtube api
      cb(self.loadNewVideos(videosData, []));
      self.showError();
    });
  }
};

/**
 * Returns a list of videoinfos from cache for urls in videosData
 *
 * @param {!Array} videosInfos list containing videos info
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.getVideosInfoFromCache = function(videosData) {
  var self = this;
  return videosData.map(function(data) {
    return self.videoInfoCache[data.video.url];
  });
};

/**
 * Returns a list of videos from data, updates the cache
 *
 * @param {!Array} videos list containing videos of type yext.entity.fields.video.YouTubeVideo
 * @param {!Array} videoInfos list containing video infos from youtube api (might be empty in some cases)
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.loadNewVideos = function(videosData, videoInfos) {
  var self = this;
  var videos = [];

  for (var i = 0; i < videosData.length; i++) {
    var data = videosData[i];
    var info = videoInfos.find(i => i.id === yext.youtube.parseIdFromUrl(data.video.url));

    self.videoInfoCache[data.video.url] = info;
    data.video.youTubeVideoInfo = info;

    var video = new yext.entity.fields.video.YouTubeVideo(
      data,
      self.thumbnailTemplate,
      self.editTemplate,
      self.viewTemplate,
      self.viewOnly,
      self.fieldId,
      self.displayDescription);

    self.bindVideo(video);
    videos.push(video);
  }
  return videos;
};

/**
 * Returns true if all the url are already present in the cache
 *
 * @param {!Array} videosData list containing videos data
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.allValuesInCache = function(videosData) {
  var self = this;
  return videosData.every(function(data) {
    return !!self.videoInfoCache[data.video.url];
  });
};

/**
 * Helps bind additional properties for field
 *
 * @param {!Object} videoData object containing video data
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.extractDataFromJson = function(videoData) {
  const description = videoData['description'];
  if (description && description.value && !description.displayValue) {
    description.displayValue = description.value;
  }
  return {
    video: {
      url: videoData['url'],
      indeterminate: videoData['indeterminate'],
    },
    description: videoData['description'],
  };
};

/**
 * Helps bind additional properties for field
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.continueSetup = function(overridden = false) {
  this.renderDisplayView();

  // if the videos were inherited from the primary profile, continue setup as if they weren't there
  if (overridden) {
    this.model.videos = [];
    this.model.elidedVideoCount = undefined;
  }

  this.storeValue();
  this.addVideosToDOM();
  this.render();
  this.setFieldValue();
  this.bindAddVideo();
  this.bindEditAllCheckbox();
  this.bindMoveVideo();
  this.bindElidedMode();
};

/**
 * Bind the video selected checkbox
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.bindEditAllCheckbox = function() {
  if (this.$editAllCheckbox.length) {
    var self = this;
    this.$editAllCheckbox.on('click change', function() {
      if (self.isIndeterminate()) {
        self.$editAllCheckbox.prop('checked', true);
      }
      self.$list.find('input[type="checkbox"]')
        .prop({
          indeterminate: false,
          checked: self.$editAllCheckbox.prop('checked'),
        })
        .trigger('change');
    });
  }
};

/**
 * Bind the move video affordances using jQuery sort
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.bindMoveVideo = function() {
  var self = this;
  this.$list.sortable({
    handle: '.js-move-video-affordance',
    axis: 'y',
    stop: function(e, ui) {
      self.reordered();
      // Note (schakraborty): Firefox sets top/left to 0 on stop, which causes the
      // image to be misaligned the next time it gets dragged. Explicitly
      // set top/left to auto to fix this.
      ui.item
        .css('top', 'auto')
        .css('left', 'auto');
    },
    containment: self.$list,
    tolerance: 'pointer',
  });
};

/**
 * Triggered when the video gallery is reordered
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.reordered = function() {
  var videos = [];

  this.$list.find('.js-video-edit-row').each(function() {
    videos.push($(this).data('video'));
  });

  this.model.videos = videos;
  this.model.orderVaries = false;
  this.onUpdate();
};

/**
 * Bind the elided mode interaction
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.bindElidedMode = function() {
  var self = this;
  this.$elidedModeContainer.find('.js-elided-mode-delete').click(function() {
    self.model.elidedVideoCount = undefined;
    self.model.orderVaries = false;
    self.onUpdate();
  });
};

/**
 * Returns true if any video is indeterminate
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.isIndeterminate = function() {
  return this.model.videos.some(function(video) {
    return video.isIndeterminate();
  });
};

/**
 * Returns true if all videos are checked
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.allVideosSelected = function() {
  return this.model.videos.every(function(video) {
    return video.isSelected();
  });
};

/**
 * Inserts view for YouTubeVideoList in DOM
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.renderDisplayView = function() {
  if (this.isElidedMode()) {
    this.$viewDisplay.empty().append(this.renderElidedModeMessage());
  } else if (this.isEmpty()) {
    this.$viewDisplay.empty().append(yext.location.helpers.emptyFieldMessage());
  } else if (this.isIndeterminate()) {
    this.$viewDisplay.empty().append(yext.location.helpers.variousContentMessage());
  } else if (this.model.videos.length > 0) {
    var items = [];
    for (var i = 0; i < this.model.videos.length; i++) {
      items.push('<li>' + this.model.videos[i].templateView() + '</li>');
    }
    this.$viewDisplay.empty().append('<ul>' + items.join('') + '</ul>');
  }
};

/**
 * Return true if there is a elidedVideoCount
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.isElidedMode = function() {
  return this.model.elidedVideoCount != undefined;
};

/**
 * Return the correct I18n pluralization if elided mode, or empty
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.renderElidedModeMessage = function() {
  if (this.model.elidedVideoCount) {
    return yext.msgn('1 Video', '{0} Videos', this.model.elidedVideoCount);
  }
  return '';
};

/**
 * Return true if the field is empty
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.isEmpty = function() {
  return this.model.videos.length === 0 && !this.isElidedMode();
};

/**
 * Store the value of this field
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.storeValue = function() {
  this.storedValue = {
    videos: this.model.videos.map(function(video) {
      return video.getData();
    }),
    elidedVideoCount: this.model.elidedVideoCount,
    orderVaries: this.model.orderVaries,
  };
};

/**
 * 'Add youtube video' links
 *
 * Bind click events to show the add youtube video dialog
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.bindAddVideo = function() {
  var self = this;
  this.$addVideoButton.on('click', function() {
    self.showAssetSelector();
  });
};

/**
 * Show/bind the asset selector
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.showAssetSelector = function() {
  var self = this;

  yext.dam.assetselector.events.show(
    {
      type: yext.dam.assetselector.types.VIDEO,
      includeUsedAssets: false,
      hideNonAssetVideoTabs: self.assetsOnly,
      isSuggestedEditMode: false,
      usageType: goog.module.get('yext.dam.assetselector.usage').forProfileFields(self.fieldId),
    },
    self.fieldId);
  $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
    if (self.isVideoDuplicate(asset.videoinfo.url)) {
      self.showError(yext.msg('This video has already been selected.'));
    } else {
      self.newVideoFromAsset(asset);
    }
  });
};

/**
 * Show an error when something goes wrong
 *
 * @param {string} msg Error message to display
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.showError = function(msg) {
  msg = msg || yext.msg('Something went wrong, please reload the page');
  this.$errorContainer.html(msg).show();
};

/**
 * Returns true if video with url already exists
 *
 * @param {string} url url of the new video
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.isVideoDuplicate = function(url) {
  return this.model.videos.some(function(video) {
    return url == video.model.url;
  });
};

/**
 * Creates new YouTubeVideo from asset
 *
 * @param {!Object} asset data selected from asset selector
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.newVideoFromAsset = function(asset) {
  if (typeof asset === 'undefined') {
    return;
  }
  var self = this;
  var data = {
    video: {
      url: asset.videoinfo.url,
    },
    description: {
      value: asset.description,
      displayValue: asset.description,
    },
  };

  this.extractVideos([data], function(videos) {
    var video = videos[0];
    self.addVideoToDOM(video);
    self.model.videos.push(video);
    $(self).trigger('newVideoFromAsset');
    self.setFieldValue();
    self.render();
  });
};

/**
 * When any updates are made to the field, this method is called
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.onUpdate = function() {
  this.emitUpdate();
  this.setFieldValue();
  this.render();
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/*
 * Adds all the videos on the model to the DOM
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.addVideosToDOM = function() {
  this.$list.empty();
  for (var i = 0; i < this.model.videos.length; i++) {
    this.addVideoToDOM(this.model.videos[i]);
  }
};

/**
 * Adds a single video to the DOM
 *
 * @param {yext.entity.fields.video.YouTubeVideo} video
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.addVideoToDOM = function(video) {
  var $li = $('<li>');
  $li.append(video.$ctx);
  this.$list.append($li);
};

/**
 * Renders the field
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.render = function() {
  this.$errorContainer.hide();
  this.$elidedModeContainer.toggle(!!this.model.elidedVideoCount);
  this.$elidedModeContainer.find('.js-elided-mode-message')
    .html(this.renderElidedModeMessage());
  this.$editAllContainer.toggle(this.model.videos.length > 1);
  this.$editAllContainer.find('.js-video-list-edit-all-text').html(this.renderEditAllMessage());
  this.$orderVaries.toggle(this.model.orderVaries);
  this.syncCheckList();
};

/**
 * Return the correct I18n pluralization of the total number of videos
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.renderEditAllMessage = function() {
  return yext.msgn('1 Video', '{0} Videos', this.model.videos.length);
};

/**
 * Bind the video events
 *
 * @param {yext.entity.fields.video.YouTubeVideo} video
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.bindVideo = function(video) {
  var self = this;
  $(video).on('updated', function() {
    self.onUpdate();
  });
  $(video).on('delete', function() {
    video.$ctx.closest('li').remove();
    var index = self.model.videos.indexOf(video);
    self.model.videos.splice(index, 1);
    self.onUpdate();
  });
};

/**
 * Reset the field to its stored state
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.reset = function() {
  this.set(this.storedValue, function() {});
};

/**
 * Sets the checklist checkbox to appropriate state
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.syncCheckList = function() {
  if (this.$editAllCheckbox.length) {
    this.$editAllCheckbox.prop('indeterminate', this.isIndeterminate() && this.allVideosSelected());
    this.$editAllCheckbox.prop('checked', this.allVideosSelected());
  }
};

/**
 * Set the field with new data
 *
 * @param {!Object} jsonData
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.setFromResponse = function(jsonData) {
  var self = this;
  var videos = jsonData['videos'].map(function(jsonVideo) {
    return self.extractDataFromJson(jsonVideo);
  });

  var data = {
    videos: videos,
    orderVaries: jsonData['orderVaries'],
    timestamp: jsonData['timestamp'],
    elidedVideoCount: jsonData['elidedVideoCount'],
    indeterminate: jsonData['indeterminate'],
  };
  this.set(data, function() {
    self.renderDisplayView();
  });
};

/**
 * Set the field with new data
 *
 * @param {!Object} data
 * @param {callback} cb
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.set = function(data, cb) {
  var self = this;
  var videos = data.videos;

  this.model.elidedVideoCount = data.elidedVideoCount;
  this.model.orderVaries = Boolean(data.orderVaries);

  if (data.timestamp) {
    this.model.timestamp = data.timestamp;
  }

  if (videos.length == 0) {
    this.model.videos = [];
  }

  this.extractVideos(videos, function(videos) {
    self.model.videos = videos;
    self.preSet();
    cb();
  });
};

/**
 * Executes necessary updates during set operation
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.preSet = function() {
  this.addVideosToDOM();
  this.render();
  this.setFieldValue();
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.setFieldValue = function() {
  var jsonData = {
    'timestamp': this.model.timestamp,
    'elidedVideoCount': this.model.elidedVideoCount,
    'orderVaries': this.model.orderVaries,
    'videos': this.getVideoListData(),
  };
  this.$fieldValue.val(yext.JSON.stringify(jsonData));
};

/**
 * Returns the formatted data for YouTubeVideoListField
 */
yext.entity.fields.video.YouTubeVideoListField.prototype.getVideoListData = function() {
  return this.model.videos
    .filter(function(video) {
      return video.isSelected();
    })
    .map(function(video) {
      return {
        'url': video.getData().video.url,
        'description': video.getData().description,
        'indeterminate': video.getData().video.indeterminate,
      };
    });
};
